const enUS = {
  common: {
    openWpsExperience: 'Open WPS Office',
    download: 'Download',
    wpsOffice: 'WPS Office',
    claimNow: 'Claim Now',
  },
  page: {
    downloadTitle: 'Download WPS Office',
    companyName: 'Zhuhai Kingsoft Office Co., Ltd.',
  },
  tip: {
    upgradeForMore: 'Please upgrade to the latest version for more features',
    unsupportedOpenInApp: {
      weixin: {
        title: 'Cannot open the app in WeChat',
        step1: '1. Tap the top-right button',
        step2: '2. Select "Open in default browser"',
      },
      qq: {
        title: 'Cannot open the app in QQ',
        step1: '1. Tap the top-right button',
        step2: '2. Select "Browser"',
      },
      weibo: {
        title: 'Cannot open the app in Weibo',
        step1: '1. Tap the top-right button',
        step2: '2. Select "Open in browser"',
      },
    },
  },
  ability: {
    buttonTip: {
      developing: 'This feature is under development',
      opening: 'Opening WPS Office',
      mobileOnly: 'Please use WPS Office on mobile',
      androidOnly: 'Please use WPS Office on Android',
      iosOnly: 'Please use WPS Office on iOS',
    },
  },
  template: {
    title: 'WPS Office',
    desc: 'Work efficiently anytime, anywhere',
    featureIntro: 'Feature Introduction',
    t001: {
      title: 'Export to PDF',
      introduction: 'Convert your document to PDF format',
      desc1: 'Convert Writer, Spreadsheets, and Presentation files to PDF',
      desc2: 'PDF is easier to save, read, and print',
      desc3: 'Free to use at any time',
    },
  },
};

export default enUS;
